// import _ from 'lodash';
import moment from 'moment'

const ongoingDeal = {
  isLoading: {
    list: false,
    modal: false,
    form: false,
  },
  data: {
    title: '',
    description: '',
    supplierReference: '',
    durationFrom: moment().format('DD/MM/YYYY'),
    durationTo: moment().add(1, 'month').format('DD/MM/YYYY'),
    assignedCustomerGroups: [],
    assignedCustomers: [],
    modifiedRows: [],
  },
  products: [],
}
const OngoingDealReducer = function (state = ongoingDeal, action) {
  switch (action.type) {
    case 'TOGGLE_ONGOING_DEAL_LOADING': {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_ONGOING_DEAL_PRODUCTS': {
      let newList = {}
      Object.entries(action.products).forEach(([key, value]) => (newList[key] = { ...state.products[key], ...value }))
      return {
        ...state,
        products: {
          ...state.products,
          ...newList,
        },
      }
    }
    case 'UPDATE_ONGOING_DEAL_ROW_DATA': {
      if (state.isLoading.form) {
        return state
      }

      const newModifiedRows = {
        ...state.data.modifiedRows,
        [action.key]: action.value,
      }

      const newData = {
        ...state.data,
        modifiedRows: newModifiedRows,
      }

      return {
        ...state,
        data: newData,
      }
    }
    case 'REPLACE_ONGOING_DEAL_DATA': {
      const oldModifiedRows = state.data.modifiedRows

      const newData = {
        ...state.data,
        ...action.value,
      }

      if (oldModifiedRows.length) {
        newData.modifiedRows = [...oldModifiedRows, ...action.value.modifiedRows]
      }

      return {
        ...state,
        data: newData,
      }
    }
    case 'UPDATE_ONGOING_DEAL_DATA': {
      if (state.isLoading.form) {
        return state
      }

      const newData = {
        ...state.data,
        [action.key]: action.value,
      }

      return {
        ...state,
        data: newData,
      }
    }
    default: {
      return state
    }
  }
}

export default OngoingDealReducer
